import dataService from 'utils/dataservice';
import { TYPE_KEY, VERSION_KEY, LANG_KEY, ID, queryFilters } from './product.constants';
import { generateQuery, generateQueryFromMetaData } from '../common/search/search.helper';
import cloneDeep from "lodash.clonedeep";
import {isEmptyChk } from 'utils/common';
export function withdraw(data) {
    return dataService.postRequest('pwithdraw', { data })
}
export function reject(data) {
    return dataService.postRequest('preject', { data })
}
export function upsertProduct(processedData, lang) {
    return dataService.postRequest('upsertProduct', { data: { ...processedData }, [LANG_KEY]: lang })
}
export function exportToEdit(searchQuery, isIncludeAllLang) {
    let sq2 = cloneDeep(searchQuery)       
    let itemWithPh2_id = !isEmptyChk(sq2.query.q.advanced) && sq2.query.q.advanced.find(item=> item.fields[0] == "ph2_id")
    if(itemWithPh2_id) itemWithPh2_id.fields[0] = "ph2_id.value";
    
    return dataService.postRequest('productExportToEdit', {...sq2, includeAllLang: isIncludeAllLang}  )
}
export function exportToApprove(data, searchQuery) {
    let sq2 = cloneDeep(searchQuery)       
    let itemWithPh2_id = !isEmptyChk(sq2.query.q.advanced) && sq2.query.q.advanced.find(item=> item.fields[0] == "ph2_id")
    if(itemWithPh2_id) itemWithPh2_id.fields[0] = "ph2_id.value";
    return dataService.postRequest('pExportToApprove', {...sq2}  )
}
export function submitAllForApproval(searchQuery) {
    let sq2 = cloneDeep(searchQuery)       
    let itemWithPh2_id = !isEmptyChk(sq2.query.q.advanced) && sq2.query.q.advanced.find(item=> item.fields[0] == "ph2_id")
    if(itemWithPh2_id) itemWithPh2_id.fields[0] = "ph2_id.value";
    return dataService.postRequest('pRequestApprovalAll', {...sq2})
}
export function submitAllForPublished(searchQuery) {
    let sq2 = cloneDeep(searchQuery)       
    let itemWithPh2_id = !isEmptyChk(sq2.query.q.advanced) && sq2.query.q.advanced.find(item=> item.fields[0] == "ph2_id")
    if(itemWithPh2_id) itemWithPh2_id.fields[0] = "ph2_id.value";
    return dataService.postRequest('pRequestPublishedAll', {...sq2})
}
export function approveAll(searchQuery) {
    let sq2 = cloneDeep(searchQuery)       
    let itemWithPh2_id = !isEmptyChk(sq2.query.q.advanced) && sq2.query.q.advanced.find(item=> item.fields[0] == "ph2_id")
    if(itemWithPh2_id) itemWithPh2_id.fields[0] = "ph2_id.value";
    return dataService.postRequest('pApproveAll', {...sq2})
}
export function deleteInline(data) {
    return dataService.deleteRequest('pDelete', { ...data })
}
export function approveInline(data) {
    return dataService.postRequest('plaunch', { 'data': data })
}
export function submitForApproval(data) {
    return dataService.postRequest('pRequestApproval', { 'data': data })
}
export function submitForPublished(data) {
    return dataService.postRequest('pRequestPublished', { 'data': data })
}
export function cancel(data) {
    return dataService.postRequest('pcancel', { 'data': data })
}
export function getProductList(sq) {
    return dataService.postRequest('productList', sq)
}
export function getProductCount(sq) {
    return dataService.postRequest('productCount', sq)
}
export function getProductFieldsMetaData(type, lang, version) {
    // let sq = {[TYPE_KEY] : applnType}
    let sq = { [TYPE_KEY]: type, [LANG_KEY]: lang, [VERSION_KEY]:version }

    return dataService.postRequest('productFieldsMetaData', sq)
}
export function getFormData(id, lang, version) {
    let sq = { [ID]: id, [LANG_KEY]:lang, [VERSION_KEY]:version }
    return dataService.getRequest('productData', sq)
}
export function getMetaData(lang, version) {
    let sq = { [LANG_KEY]:lang, [VERSION_KEY]:version }
    return dataService.getRequest('productMetaData', sq)
}

export function getSearchSuggestions(searchValue, searchCategory, valueArr) {
    const query = generateQuery(searchValue, queryFilters[searchCategory], valueArr);
    return dataService.postRequest('getProdSuggestions', query);
}

export function getProductSuggestions(searchValue, searchCategory, valueArr, lang, fullData) {
    const query = generateQueryFromMetaData(searchValue, searchCategory, valueArr, lang, fullData);
    return dataService.postRequest('getProdSuggestions', query);
}

export function getProdSuggestions(query, formData) {
    const reqURL = {
        userType: "BUYER",
        q: {
            term: query,
            completionFields: ["completion_sap_product_id", "completion_display_name"],
            lang: "EN",
            fields: [
                "display_name",
                "sap_product_id",
                "o_id"
            ],
            contextFilter: [
                {
                    "field": "market_code",
                    "value": [formData.market || ""]
                },
                // {
                //     "field": "cms_id",
                //     "value": [formData.cms_id || ""]
                // },
                {
                    "field": "workflowstate",
                    "value": ["published"]
                }
            ]
        },
        page: 1
    };
    return dataService.postRequest('getProdSuggestions', reqURL);
}